class HotspotComponent extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
  }

  connectedCallback() {
    this.dots = Array.from(this.querySelectorAll('.hotspot-section-container-poster--dots'));
    this.products = Array.from(this.querySelectorAll('.custom-product-hotspot'));
    this.prevButton = this.querySelector('[data-hotspot-prev]');
    this.nextButton = this.querySelector('[data-hotspot-next]');

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.show(index));
    });

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.show(this.currentIndex - 1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.show(this.currentIndex + 1));
    }
  }

  show(index) {
    const total = this.products.length;
    if (!total) return;
    this.currentIndex = (index + total) % total;

    this.dots.forEach((dot, i) => dot.classList.toggle('active', i === this.currentIndex));
    this.products.forEach((product, i) => product.classList.toggle('hidden', i !== this.currentIndex));
  }
}

customElements.define('hotspot-component', HotspotComponent);